<div class="bg-grey-100 w-full">
    <div class="inner-page-wrapper flex w-full flex-col items-center justify-between gap-24 py-40 md:flex-row">
        <div class="flex w-full flex-1 flex-col gap-12 text-black">
            <div class="text-34 leading-41">
                <ng-content select="[headline]" />
            </div>
            <div class="font-headline text-18 leading-27">
                <ng-content select="[subheadline]" />
            </div>
        </div>
        <div class="w-full md:flex md:w-max md:justify-end">
            <a
                class="button-primary w-auto"
                [hyundaiRouterLink]="primaryButton()"
                [trackingElTarget]="primaryButton()"
                tracking
                trackingElType="button"
                trackingElEvent="engagement_click"
                trackingElLabel="Test Drive"
            >
                {{ primaryButtonText() }}
            </a>
        </div>
    </div>
</div>
